import { Component, HostBinding, Input, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

/**
 * Component to render content in a dialog.
 * Adds the necessary spacing, a header, close button, and actions at the bottom
 */
@Component({
    selector: 'app-dialog-content',
    templateUrl: './dialog-content.component.html',
    styleUrls: ['./dialog-content.component.scss'],
})
export class DialogContentComponent implements OnInit {


    @HostBinding('class.dialog')
    diaglog: boolean = true

    /**
     * The title for the header
     */
    @Input() title!: string
    @Input() hiddenCloseButton: boolean =false;

    CLOSE_LOCALIZED: string = $localize`:Close label text|close label text @@Close:Close`;
    constructor(private _dialogRef: MatDialogRef<any>) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    close() {
        this._dialogRef.close()
    }
}
